import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { getAdminDetails } from "../../../api/endpoints/admin";

const AdminFormModal = ({ show, onClose, onSave, adminId }) => {
  const [form, setForm] = useState({
    admin_id: "",
    first_name: "",
    last_name: "",
    email_id: "",
    mobile: "",
    admin_status: "",
  });

  const [validated, setValidated] = useState(false);
  const isEdit = !! adminId;

  useEffect(() => {
    const fetchData = async () => {
      if (isEdit && show) {
        try {
          const response = await getAdminDetails(adminId);
          if (response.status === 200) {
            const data = response.data.data;
            setForm({
              admin_id: data.admin_id || "",
              first_name: data.first_name || "",
              last_name: data.last_name || "",
              email_id: data.email_id || "",
              mobile: data.mobile || "",
              admin_status: data.admin_status ? "Active": "Block" || "Block",
            });
          }
        } catch (err) {
          console.error("Error fetching admin:", err);
        }
      } else {
        setForm({
          admin_id: "",
          first_name: "",
          last_name: "",
          email_id: "",
          mobile: "",
          admin_status: "",
        });
      }
    };
    fetchData();
  }, [adminId, show]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const formElement = e.currentTarget;

    if (formElement.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      return;
    }

    onSave(form);
    onClose();
  };

  return (
    <div className={`modal fade ${show ? "show d-block" : ""}`} tabIndex="-1">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header bg-light p-3">
            <h5 className="modal-title">{isEdit ? "Edit Admin" : "Add Admin"}</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <form 
            onSubmit={handleSubmit} 
            className={`tablelist-form needs-validation ${validated ? "was-validated" : ""}`}
            noValidate
            autoComplete="off"
          >
            <div className="modal-body">
              {isEdit && (
                <div className="mb-3">
                  <label className="form-label">Admin ID</label>
                  <input type="text" className="form-control cursor-default bg-gray-100" value={form.admin_id} readOnly />
                </div>
              )}

              <div className="mb-3">
                <label className="form-label">First Name</label>
                <input
                  type="text"
                  name="first_name"
                  value={form.first_name}
                  onChange={handleChange}
                  className="form-control"
                  required
                />
                <div className="invalid-feedback">Please enter the first name.</div>
              </div>
              <div className="mb-3">
                <label className="form-label">Last Name</label>
                <input
                  type="text"
                  name="last_name"
                  value={form.last_name}
                  onChange={handleChange}
                  className="form-control"
                  required
                />
                <div className="invalid-feedback">Please enter the last name.</div>
              </div>
              {!isEdit && (
              <div className="mb-3">
                <label className="form-label">Password</label>
                <input
                  type="password"
                  name="admin_password"
                  value={form.password}
                  onChange={handleChange}
                  className="form-control"
                  minLength="5"
                  autoComplete="off"
                  required
                />
                <div className="invalid-feedback">Please enter password.</div>
              </div> ) }
              {!isEdit ?(
              <div className="mb-3">
                <label className="form-label">Email</label>
                <input
                  type="email"
                  name="email_id"
                  value={form.email_id}
                  onChange={handleChange}
                  className="form-control"
                  pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$"
                  required
                />
                <div className="invalid-feedback">Please enter a valid email.</div>
              </div>
              ):(
                <div className="mb-3">
                  <label className="form-label">Email</label>
                  <input type="text" className="form-control cursor-default bg-gray-100" value={form.email_id} readOnly />
                </div>
              )}
              <div className="mb-3">
                <label className="form-label">Mobile</label>
                <input
                  type="text"
                  name="mobile"
                  value={form.mobile}
                  onChange={handleChange}
                  className="form-control"
                  pattern="^[0-9]{10}$"
                  maxLength="10"
                  required
                />
                <div className="invalid-feedback">Please enter a valid 10-digit mobile number.</div>
              </div>
              <div>
                <label className="form-label">Status</label>
                <select
                  name="admin_status"
                  value={form.admin_status}
                  onChange={handleChange}
                  className="form-control"
                  required
                >
                  <option value="">Select status</option>
                  <option value="Active">Active</option>
                  <option value="Block">Block</option>
                </select>
                <div className="invalid-feedback">Please select a status.</div>
              </div>
            </div>

            <div className="modal-footer">
              <button type="button" className="btn btn-light" onClick={onClose}>
                Close
              </button>
              <button type="submit" className="btn btn-success">
                {isEdit ? "Update Admin" : "Add Admin"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

AdminFormModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  adminId: PropTypes.string,
};

export default AdminFormModal;